const basico11 = {
    titulo: `JavaScript: estructura repetitiva for`,
    problemas: [
      {
        codigo: 1,
        descripcion: `Cualquier problema que requiera una estructura repetitiva se puede resolver empleando la estructura while. Pero hay otra estructura repetitiva cuyo planteo es más sencillo en ciertas situaciones.
Esta estructura se emplea en aquellas situaciones en las cuales CONOCEMOS la cantidad de veces que queremos que se ejecute el bloque de instrucciones. Ejemplo: cargar 10 números, ingresar 5 notas de alumnos, etc. Conocemos de antemano la cantidad de veces que queremos que el bloque se repita.
Por último, hay que decir que la ejecución de la sentencia break dentro de cualquier parte del bucle provoca la salida inmediata del mismo.
Sintaxis:
<pre>
for (&lt;Inicialización&gt; ; &lt;Condición&gt; ; &lt;Incremento o Decremento&gt;)
{
  &lt;Instrucciones&gt;
}
</pre>        
Esta estructura repetitiva tiene tres argumentos: variable de inicialización, condición y variable de incremento o decremento.        
Funcionamiento:
<pre>
1 - Primero se ejecuta por única vez el primer argumento <Inicialización>.
    Por lo general se inicializa una variable.
2 - El segundo paso es evaluar la (Condición), en caso de ser verdadera 
    se ejecuta el bloque, en caso contrario continúa el programa.
3 - El tercer paso es la ejecución de las instrucciones.
4 - El cuarto paso es ejecutar el tercer argumento (Incremento o Decremento).
5 - Luego se repiten sucesivamente del Segundo al Cuarto Paso.
</pre>        
Este tipo de estructura repetitiva se utiliza generalmente cuando sabemos la cantidad de veces que deseamos que se repita el bloque.
Ejemplo: Mostrar por pantalla los números del 1 al 10.
<pre>
for (let f = 1; f <= 10; f = f + 1) {
  console.log(f)
}
</pre>
Un operador matemático que no hemos visto es el operador ++. Este operador incrementa en uno el valor de una variable. Luego es común utilizarlo en un for remplazando  el icremento de f:
<pre>
for (let f = 1; f <= 10; f++) {
  console.log(f)
}  
</pre>
También existe otro operador matemático que decrementa en uno el valor de una variable: --
Problema: Sumar todos los valores comprendidos entre 1 y 10`,
        programa: `let suma = 0
for (let f = 1; f <= 10; f++) {
  suma = suma + f
}
console.log(suma)`,
        solucion: "55",
      }, {
        codigo: 2,
        descripcion: `El incremento o decremento de una variable puede ser un número distinto a 1.
Sumar todos los valores pares comprendidos entre 2 y 10.`,
        programa: `let suma = 0
for (let i = 2; i <= 10; i = i + 2) {
  suma = suma + i
}
console.log(suma)`,
        solucion: "30",
      }
    ]
  }
  
  export default basico11;